import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import TimeWatchPage from "../components/TimeWatchPage";
import OraTimeButton from "../components/voice/OraTimeButton";
import OrientationControlButton from "../components/OrientationControlButton";
import NdaGate from "../components/nda/NdaGate";

/**
 * Wrapper that renders the existing TIME Watch (untouched) with a small
 * floating "back to Innovazione" link on top. The TIME Watch itself is not
 * modified in any way.
 */
export default function TimeWatchRoute() {
  return (
    <div className="relative">
      <Link
        to="/innovazione/time-watch"
        data-testid="time-watch-back-link"
        className="fixed top-3 left-3 z-50 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full backdrop-blur-md bg-black/50 border border-white/10 text-[10px] tracking-[0.28em] uppercase text-white/70 hover:text-white hover:border-white/25 transition"
      >
        <ChevronLeft className="w-3 h-3" />
        TIME Watch
      </Link>
      <TimeWatchPage />
      <OraTimeButton />
      <OrientationControlButton />
      {/* NDA gate also covers the fullscreen TIME Watch route (outside layout shell). */}
      <NdaGate />
    </div>
  );
}
